import { extract, nextItem, previousItem, useArrayKeyboardHandler, } from '@vpap_svelte/internal';
export function useFlatKeyboard(options) {
    let data = $derived(extract(options.data, []));
    let handler = useArrayKeyboardHandler({ orientation: options.orientation ?? 'horizontal' });
    let cursor = $state(undefined);
    const next = () => {
        const n = nextItem(data, cursor ?? -1, { wrapEnd: options.wrap, skipIf: options.skipIf });
        // we need to specifically avoid having the cursor set when the next item becomes undefined
        // If we set it as undefined in this case, the wrapping behavior will be incorrect:
        if (n !== undefined) {
            cursor = n;
        }
    };
    const previous = () => {
        const p = previousItem(data, cursor ?? 0, {
            wrapStart: options.wrap,
            skipIf: options.skipIf,
        });
        if (p !== undefined) {
            cursor = p;
        }
    };
    return {
        get data() {
            return data;
        },
        reset() {
            cursor = undefined;
        },
        next,
        previous,
        get selection() {
            if (cursor === undefined)
                return undefined;
            return {
                selected: data[cursor],
                idx: cursor,
                data,
            };
        },
        get cursor() {
            return cursor;
        },
        get attributes() {
            return {
                role: 'application',
                tabindex: 0,
                onkeydown: (e) => {
                    const isNext = handler.isNextKey(e);
                    const isPrevious = handler.isPreviousKey(e);
                    if (!(isNext || isPrevious))
                        return;
                    e.preventDefault();
                    if (isNext) {
                        next();
                    }
                    else {
                        previous();
                    }
                },
                onblur: () => {
                    this.reset();
                },
            };
        },
    };
}
